import { ISelectOptions } from "aw-combobox";
import { LANGUAGES, ROLES } from "aw-consts";
import { useTranslation } from "react-i18next";

export const ApiVersion = '/api/v1/'

export const AdminUser = 'admin@awayter.com'

export const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

export const UserRoles = () => {
    const { t } = useTranslation();
    return [
        { label: t('Admin'), value: ROLES.Administrator },
        { label: t('Owner'), value: ROLES.Owner }
    ]
}

export const UserAdminRoles = () => {
    const { t } = useTranslation();
    return [
        { label: t('Admin'), value: ROLES.Administrator },
        { label: t('Owner'), value: ROLES.Owner },
        { label: t('Demo'), value: ROLES.Demo }
    ]
}


export const UserLanguages = () => {
    const { t } = useTranslation();
    return [
        { label: t('Catalan'), value: LANGUAGES.Catalan, id: 'cat' },
        { label: t('Castellano'), value: LANGUAGES.Castellano, id: 'es' },
        { label: t('Ingles'), value: LANGUAGES.Ingles, id: 'eng' },
        { label: t('Frances'), value: LANGUAGES.Frances, id: 'fr' }
    ]
}

export const ThemeOptions = () => {
    const { t } = useTranslation();
    return [
        { label: t('Light'), value: 'light', icon: 'bi bi-sun-fill' },
        { label: t('Dark'), value: 'dark', icon: 'bi bi-moon-fill' },
        { label: t('Personalized'), value: 'personalized', icon: 'bi bi-brush-fill' }
    ]
}

export const MachineTypes = () => {
    const { t } = useTranslation();
    return [
        { label: t('Purifier'), value: 0 }
    ]
}

export enum salesListTypes {
    DashboardGeneral,
    DashboardInstalation,
    DashboardMachine
}

export enum ImagesTypes {
    CompanyLogo,
    EventLogo,
    InitialScreen,
    DeliveryScreen,
    Glass,
    Glass2
}

export enum AssistanceTypes {
    Installation,
    Assistance,
    Alert,
    Maintenance
}

export enum AssistanceStates {
    Pending,
    InProgress,
    Completed,
}

export const getAssistanceTypesColor = (id: number) => {
    let color = '007bff'
    switch (id) {
        case 0:
            color = '#007bff'
            break;
        case 1:
            color = '#E41357'
            break;
        case 2:
            color = '#fcb823'
            break;
        case 3:
            color = '#036e27'
            break;
        default:
            color = '#007bff'
            break;
    }
    return color
}

export const GetAssistancesTypeOptions = () => {
    const { t } = useTranslation();
    const assistancesTypesObj: ISelectOptions[] = []
    let i = 0
    for (const type in AssistanceTypes) {
        if (!isNaN(Number(type))) {
            assistancesTypesObj.push({ value: Number(type), label: '' })
        } else {
            assistancesTypesObj[i].label = t(type)
            i++
        }

    }
    return assistancesTypesObj
}

export const GetAssistancesStatesOptions = (): ISelectOptions[] => {
    const { t } = useTranslation();

    return Object.keys(AssistanceStates)
        .filter((key) => isNaN(Number(key)))
        .map((key) => ({
            value: AssistanceStates[key as keyof typeof AssistanceStates],
            label: t(key),
        }));
};

export const isTabletScreen = () => {
    return window.innerWidth < 1300 && window.innerWidth > 700;
};

export enum SubscriptionType {
    Inactive,
    Trial,
    Active,
    Expired,
    Canceled
}

export const SubscriptionTypeList = () => {
    const { t } = useTranslation();
    return [
        { label: t('Inactive'), value: Number(SubscriptionType.Inactive) },
        { label: t('Trial'), value: Number(SubscriptionType.Trial) },
        { label: t('Active'), value: Number(SubscriptionType.Active) },
        { label: t('Expired'), value: Number(SubscriptionType.Expired) },
        { label: t('Canceled'), value: Number(SubscriptionType.Canceled) }
    ]
}

export enum ConnectionType {
    NoSim,
    Sim
}

export const ConnectionTypeList = () => {
    const { t } = useTranslation();
    return [
        { label: t('No'), value: ConnectionType.Sim },
        { label: t('Yes'), value: ConnectionType.NoSim }
    ]
}